/* eslint-disable no-useless-escape */
import i18n from '@pro/common/i18n/i18n';
import Storage from './storage';
// import { mutations, store } from './store';
// import { createMockInterceptors } from '@/Common/libs/touristModeUtils';
import axios from 'axios';
import { MessageBox } from 'hui-intl';
// import { getErrorTip, handleError } from './errorHandler';
// import _ from 'lodash';
import { handleErrorDoCommon } from './handleErrorDoCommon.js';
import { handleUndefinedDoCommon } from './handleUndefinedDoCommon.js';
import CONSTANT from './constant';
const version = CONSTANT.VERSION.replace(/\s+/g, '').match(/^V([\d.]+)/)[1];
const ELB_ENUM = {
  noCdnPath: 'HPC.dicSet.noCdnPath.BASE_LINE',
  cdnPath: 'HPC.dicSet.cdnPath.BASE_LINE',
  domain: 'HPC.dicSet.apiDomain.BASE_LINE'
};
const instance = axios.create({
  baseURL: '/hpp',
  timeout: 28000,
  headers: {
    clientSource: process.env.clientSource,
    version: version,
    'If-Modified-Since': 0,
    'x-gray-version': process.env.projectId
  }
});
const prefixUrlList = [
  '/company/security/v1/crossregion/verify/'
];

// 路径匹配函数
function isPathMatch(path, patterns) {
  if (!path || !patterns || !Array.isArray(patterns)) {
    return false;
  }

  // 使用包含匹配，检查路径是否包含模式字符串
  return patterns.some((pattern) => path.includes(pattern));
}
function noNeedElb(path, parsedRes) {
  try {
    if (!path || typeof path !== 'string') {
      console.warn('Invalid path parameter:', path);
      return true;
    }
    const needCdnPath = parsedRes?.dicSetList?.find(
      (item) => item.dicSetName === ELB_ENUM['cdnPath']
    );
    if (!needCdnPath || !Array.isArray(needCdnPath.dicDataList)) {
      return true;
    }
    return needCdnPath.dicDataList.some((item) => {
      const configValue = item.dicDataValue;
      if (typeof configValue !== 'string') {
        return false;
      }
      const isExactMatch = (configValue === path);
      let isPrefixMatch = false;
      if (Array.isArray(prefixUrlList) && prefixUrlList.length > 0) {
        isPrefixMatch = prefixUrlList.some((prefix) => {
          return typeof prefix === 'string' && path.startsWith(prefix);
        });
      }
      return isExactMatch || isPrefixMatch;
    });
  } catch (error) {
    console.error('noNeedElb error:', error);
    return true;
  }
}
function checkneedElb(path, parsed) {
  try {
    if (!path || !parsed) {
      return false;
    }
    // 登录的相关请求不能走elb域名（三方登录的session会影响不使用elb域名的请求）
    if (noNeedElb(path, parsed)) {
      return false;
    }
    const dicDataList = parsed?.dicSetList.find((item) => item.dicSetName === ELB_ENUM['noCdnPath']).dicDataList;
    if (!dicDataList || !Array.isArray(dicDataList)) {
      return false;
    }
    const pathPatterns = dicDataList.map((item) => item.dicDataValue).filter(Boolean);
    return pathPatterns.length > 0 && isPathMatch(path, pathPatterns);
  } catch (error) {
    console.error('checkneedElb error:', error);
    return false;
  }
}
// function addHPP(path) {
//   if (path.includes('/hpp/')) {
//     return path;
//   }
//   return `/hpp${path}`;
// }

export const handleUserChange = () => {
  // 统一浏览器两个标签登录不同用户的处理函数
  const installerId = Storage.get(Storage.NAME.USER)['installerId'];
  if (installerId && sessionStorage.getItem('currentInstallerId')) {
    if (installerId !== sessionStorage.getItem('currentInstallerId')) {
      sessionStorage.setItem('currentInstallerId', installerId);
      window.location.reload();
    }
  }
};
instance.interceptors.request.use(
  (config) => {
    handleUserChange();

    if (config.url.includes('eigateway/ep')) {
      config.url = config.url.replace('/hpp/', '/');
      let EPConfig = { ...config, timeout: 60000, baseURL: '/' };
      return EPConfig;
    }

    const changeList = localStorage.getItem('need-change-server-key');
    let parsed = null;
    if (changeList) {
      parsed = JSON.parse(changeList);
    }
    
    if (checkneedElb(config.url, parsed)) {
      if (config.url) {
        let domainUrl = parsed?.dicSetList.find((item) => item.dicSetName === ELB_ENUM['domain'])?.dicDataList?.[0]
          ?.dicDataValue;
        // 先拼接完整的URL
        let fullUrl = domainUrl ? domainUrl + config.baseURL + config.url : config.url;
        // 使用正则表达式全局替换重复的 /hpp/
        fullUrl = fullUrl.replace(/\/hpp\/hpp\//g, '/hpp/');

        config.url = fullUrl;
        config.withCredentials = true;
      }
    }

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// let networkTimeoutingFlag = false;
let serverErrorFlag = false;
export const handleException = (err) => {
  if (err && err.response) {
    if (!serverErrorFlag) {
      serverErrorFlag = true;
      // eslint-disable-next-line new-cap
      MessageBox({
        title: i18n.t('error'),
        type: 'error',
        message: i18n.t('server_error')
      })
        .then(() => {
          serverErrorFlag = false;
          Promise.reject(err);
        })
        .catch(() => {
          serverErrorFlag = false;
          Promise.reject(err);
        });
    }
  }
  //   else {
  //     if (!networkTimeoutingFlag) {
  //       networkTimeoutingFlag = true;
  //       // eslint-disable-next-line new-cap
  //       MessageBox({
  //         title: i18n.t('error'),
  //         type: 'error',
  //         message: i18n.t('network_timeout')
  //       })
  //         .then(() => {
  //           networkTimeoutingFlag = false;
  //           Promise.reject(err);
  //         })
  //         .catch(() => {
  //           networkTimeoutingFlag = false;
  //           Promise.reject(err);
  //         });
  //     }
  //   }
};

//从响应头content-disposition中获取文件名称
//attachment; filename=Bussiness_20191015115505.csv => Bussiness_20191015115505.csv
const findFileName = (str) => {
  const ch = 'filename=';
  const index = str.indexOf(ch);
  if (index === -1) {
    return 'out.csv';
  }
  return decodeURIComponent(str.slice(index + ch.length));
};

instance.interceptors.response.use(
  (res) => {
    const result = res.data;
    const responseType = res.config.responseType;
    const resFormat = res.config.resFormat;
    if (responseType === 'blob') {
      //下载文件
      const url = window.URL.createObjectURL(new Blob([res.data]));
      // if (!res.headers['content-disposition']) {
      //     message.error('下载失败');
      //     return;
      // }
      const fileName = findFileName(res.headers['content-disposition']);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 3000);
    } else if (result.errorCode && result.errorCode !== '0') {
      if (result.errorCode === 'EZV20018') {
        // 当萤石与融合云数据不同步时，会有特定错误码
        // eslint-disable-next-line no-use-before-define
        post('/site/trusteeship/v1/compensate');
      }
      if (res.config.hasErrorHandle !== false) {
        handleErrorDoCommon(result, res);
      }
      if (res.config.url.includes('eigateway')) {
        return res;
      }
      return [null, result, res];
    }
    if (result.data === null || typeof result.data === 'undefined') {
      result.data = true;
    }
    if (res.config.url.includes('eigateway')) {
      return res;
    }
    if (resFormat && result.data !== null && typeof result.data !== 'undefined') {
      const responseStandard = handleUndefinedDoCommon(result.data, resFormat);
      result.data = responseStandard;
    }
    return [result.data, null, res];
  },
  (err) => {
    if (err.config && err.config.hasCatchHandle !== false) {
      handleException(err);
    }
    return Promise.reject(err);
  }
);

export const asyncAddScript = function (src, attrs) {
  const script = document.createElement('script');
  script.src = src;
  if (Object.keys(attrs).length > 0) {
    Object.keys(attrs).forEach((key) => {
      if (_.isNull(attrs[key])) {
        script.setAttribute(key);
      } else {
        script.setAttribute(key, attrs[key]);
      }
    });
  }
  document.body.appendChild(script);
  return new Promise((resolve, reject) => {
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      reject();
    };
  });
};

const CodeAuthMockUrls = [
  // 健康监测部分
  '/site/operations/v1/sites/status',
  '/site/operations/v2/devices/status/general',
  '/site/operations/v2/devices/status/search',
  '/deviceaccess/v1/deviceupgrade/deviceInfo',
  '/deviceaccess/v2/devicestatus/company/refresh',
  // 异常中心
  '/site/v1.1/list',
  '/site/event/v1.1/push/history',
  '/site/event/v1.1/push/real',
  // 联动规则
  '/deviceaccess/v1/linkagerule/templatecap',
  '/deviceaccess/v2/linkagerule/search',
  // 异常通知
  '/site/event/v1.1/rule/search',
  '/site/event/v1.1/push/real'
];

const CodeAuthExpireMockUrls = [
  ...CodeAuthMockUrls,
  //HOME页面
  '/company/home/v1/statics',
  '/company/home/v2/site/browse/record',
  '/company/home/v1/push/statics',
  //公司信息
  '/company/v1',
  '/company/v1/packages',
  //员工
  '/company/v1/staffs',
  '/company/manager/v1/installers/search',
  //角色
  '/company/installer/v1/roles/search',
  // 日志
  '/company/installer/v1/logs/installers',
  '/company/installer/v1/logs/search'
];

const noMockUrl = [
  '/company/v3/openregister/get/country/list',
  '/company/v1/register/admin',
  '/company/dictionary/v1/get/all',
  '/company/v1/get/country/province/list',
  '/company/v1/register/esales/company',
  '/company/v1/register/one_hik/admin'
];

const mockDealUrl = async (url, proxyToMcok) => {
  const isCodeAuthMode = Storage.get(Storage.NAME.USER).authFlag === 0; // code认证 flag
  const isCodeExpire = isCodeAuthMode && Storage.get(Storage.NAME.USER).expireTime < +new Date();
  const isTouristMode = Storage.realGet(Storage.NAME.TOURIST_MODE) === 'true';

  if (url[0] !== '/') {
    url = `/${url}`;
  }

  if (
    (proxyToMcok
      || isTouristMode
      || (isCodeAuthMode && CodeAuthMockUrls.includes(url))
      || (isCodeExpire && CodeAuthExpireMockUrls.includes(url)))
    && !noMockUrl.some(
      (item) => item === url || (url.indexOf(item) > -1 && url !== '/company/dictionary/v1/get/all/ability')
    )
  ) {
    // 同步进来的多次请求都需要阻塞住  直到mock建立完成
    // await createMockInterceptors();
    return `/mock${url}`;
  }
  return url;
};

// 参数 换位  tip:实际上入参如果是对象的形式{params, config, proxyToMcok} 可以通过解构命名参数 该方法就可以取消
const dealPramas = (params, config, proxyToMock) => {
  if (typeof params === 'boolean') {
    proxyToMock = params;
    params = null;
  }
  if (typeof config === 'boolean') {
    proxyToMock = config;
    config = null;
  }
  return [params, config, proxyToMock];
};

// url : 请求地址 params: 参数  config: axios配置  proxyToMcok: 无条件代理到mock
async function get(url, params, config, proxyToMock = false) {
  [params, config, proxyToMock] = dealPramas(params, config, proxyToMock);
  url = await mockDealUrl(url, proxyToMock);
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params,
        ...config
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// url : 请求地址 params: 参数  config: axios配置  proxyToMcok: 无条件代理到mock
async function post(url, params, config = {}, proxyToMock = false) {
  [params, config, proxyToMock] = dealPramas(params, config, proxyToMock);
  url = await mockDealUrl(url, proxyToMock);
  return new Promise((resolve, reject) => {
    instance
      .post(url, params, config)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// url : 请求地址 params: 参数
async function sendBeacon(url, params, proxyToMock = false) {
  const blob = new Blob([JSON.stringify(params)], {
    type: 'application/json; charset=UTF-8'
  });
  url = await mockDealUrl(url, proxyToMock);
  return navigator.sendBeacon(url, blob);
}

export default {
  get,
  post,
  instance,
  sendBeacon
};
